import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function Vehicles() {
    const role = localStorage.getItem("role") || "user";
    const isAdmin = role === "admin";
    const [vehicles, setVehicles] = useState([]);
    const [newVehicleNo, setNewVehicleNo] = useState('');

    const fetchVehicles = async () => {
        try {
            const res = await axios.get(`${getApiUrl()}/vehicles`);
            setVehicles(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchVehicles();
    }, []);

    const handleAdd = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${getApiUrl()}/vehicles`, { vehicle_no: newVehicleNo });
            setNewVehicleNo('');
            fetchVehicles();
        } catch (err) {
            console.error(err);
            alert("Failed to add vehicle");
        }
    };

    const handleDelete = async (id) => {
        if (!isAdmin) return alert("Only admin can delete records");
        if (!window.confirm("Delete this vehicle?")) return;
        try {
            await axios.delete(`${getApiUrl()}/vehicles/${id}`);
            fetchVehicles();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Vehicles</h2>

                <form onSubmit={handleAdd} className="mb-4">
                    <div className="row g-3">
                        <div className="col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Vehicle No"
                                value={newVehicleNo}
                                onChange={e => setNewVehicleNo(e.target.value)}
                                onFocus={(e) => e.target.select()}
                                required
                            />
                        </div>
                        <div className="col-md-2 d-grid">
                            <button type="submit" className="btn btn-primary">Add</button>
                        </div>
                    </div>
                </form>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Vehicle No</th>
                                {isAdmin && <th>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {vehicles.map(v => (
                                <tr key={v.id}>
                                    <td>{v.id}</td>
                                    <td>{v.vehicle_no}</td>
                                    {isAdmin && (
                                        <td>
                                            <button type="button" className="btn btn-danger btn-sm" onClick={() => handleDelete(v.id)}>Delete</button>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
}

export default Vehicles;
